export default "__VITE_ASSET__DPF18vlq__"